import React, { Component, useState } from 'react';
import { Container } from 'reactstrap';
import {usePopUpData} from '../../queries/popup'
import PopupDialog from '../Popup'
import { Button } from 'devextreme-react/button';

function Layout(props) {
  const [open, setOpen] = useState(true);
  
  const popUpData = usePopUpData()
  if(popUpData.loading) return <div></div>
    if(popUpData.error) return <div>error!</div>
    
    const handleClose = () => {
      setOpen(false);
      
    };
    function showInfo() {
      setOpen(true);
    }
    return (
      <div >        
        {popUpData.data.popUpMessage[0] && <PopupDialog
  popupText={popUpData.data.popUpMessage[0].htmlBody.html}
  title={popUpData.data.popUpMessage[0].displayText}
  open={open}
  onClose={handleClose}
  linkUrl={popUpData.data.popUpMessage[0].popupUrl.url}
  linkTitle={popUpData.data.popUpMessage[0].popupUrl.text}
 
/>}
        <Container>
          {props.children}
        </Container>
      </div>
    );
  
}
export default Layout;